module.exports = __webpack_public_path__ + "media/images/emoticons/basketball-87cc43ca044d64cce3659c9c6bb2257f.gif";